import Endpoints from '@/constants/endpoints';
import $http from '@/core/services/http.service';

export default class ClientService {

    public static isEmailInUse(email: string) {
        return new Promise((resolve, reject) => {
            $http.get( `${Endpoints.emailInUse}${email}`)
                .then((res) => {
                    resolve(res.data);
                }).catch((err) => {
                    reject(err);
                });
        });
    }

    public static getFiscalData(userId: string) {
        return $http.get(Endpoints.userFiscalData(userId));
    }

    public static sendNotificationsNote(data: any) {
        return $http.post(Endpoints.notificationsNoteSend(data), data);
    }

}
